export default __webpack_public_path__ + "static/media/list-icon.310ef290.svg";